import PaymentModal from './PaymentModal';
import React, { useState, useEffect, useCallback } from 'react';

const API = 'https://api.botanix.in/api/sessions';
const BOOKINGS_API = 'https://api.botanix.in/api/bookings';

const C = {
  accent:'#3AAF58', accentLight:'#EAF7EE',
  bg:'#F3F6F3', surface:'#FFFFFF',
  border:'#E2E8E2', border2:'#CDD8CD',
  text:'#1A2E1E', text2:'#3D5E44', text3:'#7A9A80',
  amber:'#D4840F', amberBg:'#FEF6E7', amberBorder:'#F0D499',
  red:'#C83333', redBg:'#FDEAEA', redBorder:'#F0B8B8',
  blue:'#2563A8', blueBg:'#EAF1FB',
};

const inr = n => '₹' + Number(Math.round(n)||0).toLocaleString('en-IN');

const LOGO = 'https://botanix.in/wp-content/uploads/2025/12/Botanix-Nature-Resort-Logo.webp';
const RESORT_NAME = 'Botanix Nature Resort';
const RESORT_ADDRESS = 'Sohna Road, Gurgaon, Haryana — 122103';
const RESORT_PHONE = '+91-9818658609';
const RESORT_EMAIL = 'reservations@botanix.in';
const RESORT_GST = 'GSTIN: 06AAGCB9754R1ZT';
const RESORT_CIN = '';

export function InvoicePrintView({ invoice, mode }) {
  const items = invoice.items || [];
  const isDetailed = mode === 'detailed';

  return (
    <div id="invoice-print" style={{ fontFamily:'Arial,sans-serif', maxWidth:750, margin:'0 auto', padding:'40px 40px', color:'#1A2E1E', background:'#fff' }}>
      {/* Header */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'flex-start', marginBottom:30, borderBottom:'3px solid #153D4B', paddingBottom:20 }}>
        <div>
          <img src={LOGO} alt="Botanix" style={{ height:60, marginBottom:8 }} />
          <div style={{ fontSize:12, color:'#555', lineHeight:1.6 }}>
            <div>{RESORT_ADDRESS}</div>
            <div>{RESORT_PHONE} | {RESORT_EMAIL}</div>
            <div>{RESORT_GST} | {RESORT_CIN}</div>
          </div>
        </div>
        <div style={{ textAlign:'right' }}>
          <div style={{ fontSize:28, fontWeight:900, color:'#153D4B', marginBottom:4 }}>
            {isDetailed ? 'TAX INVOICE' : 'INVOICE'}
          </div>
          <div style={{ fontSize:13, color:'#555' }}>
            <div><strong>Invoice No:</strong> {invoice.invoice_number}</div>
            <div><strong>Date:</strong> {new Date(invoice.invoice_date||invoice.created_at).toLocaleDateString('en-IN',{day:'numeric',month:'long',year:'numeric'})}</div>
            <div><strong>Booking:</strong> {invoice.booking_code}</div>
          </div>
        </div>
      </div>

      {/* Guest & Booking Info */}
      <div style={{ display:'grid', gridTemplateColumns:'1fr 1fr', gap:20, marginBottom:24, padding:'16px 20px', background:'#F2F2EC', borderRadius:8 }}>
        <div>
          <div style={{ fontSize:11, fontWeight:700, color:'#7A9A80', textTransform:'uppercase', marginBottom:6 }}>Bill To</div>
          <div style={{ fontSize:15, fontWeight:800, color:'#153D4B' }}>{invoice.guest_name || invoice.company_name}</div>
          {invoice.company_name && invoice.guest_name !== invoice.company_name && <div style={{ fontSize:12, color:'#555' }}>{invoice.company_name}</div>}
          {invoice.guest_phone && <div style={{ fontSize:12, color:'#555' }}>{invoice.guest_phone}</div>}
          {invoice.guest_email && <div style={{ fontSize:12, color:'#555' }}>{invoice.guest_email}</div>}
          {invoice.gst_number && <div style={{ fontSize:12, color:'#555' }}>GST: {invoice.gst_number}</div>}
        </div>
        <div>
          <div style={{ fontSize:11, fontWeight:700, color:'#7A9A80', textTransform:'uppercase', marginBottom:6 }}>Stay Details</div>
          <div style={{ fontSize:12, color:'#333', lineHeight:1.8 }}>
            <div><strong>Check-in:</strong> {invoice.check_in ? new Date(invoice.check_in).toLocaleDateString('en-IN') : '—'}</div>
            <div><strong>Check-out:</strong> {invoice.check_out ? new Date(invoice.check_out).toLocaleDateString('en-IN') : '—'}</div>
            <div><strong>Nights:</strong> {invoice.nights || 1}</div>
            <div><strong>Guests:</strong> {invoice.pax_count} pax | <strong>Nationality:</strong> {invoice.nationality || 'Indian'}</div>
            {invoice.salesperson && <div><strong>Sales:</strong> {invoice.salesperson}</div>}
          </div>
        </div>
      </div>

      {/* Line Items — Detailed Mode */}
      {isDetailed && items.length > 0 && (
        <div style={{ marginBottom:20 }}>
          <table style={{ width:'100%', borderCollapse:'collapse' }}>
            <thead>
              <tr style={{ background:'#153D4B', color:'#fff' }}>
                <th style={{ padding:'10px 12px', textAlign:'left', fontSize:12, fontWeight:700 }}>Sr</th>
                <th style={{ padding:'10px 12px', textAlign:'left', fontSize:12, fontWeight:700 }}>Description</th>
                <th style={{ padding:'10px 12px', textAlign:'center', fontSize:12, fontWeight:700 }}>Qty</th>
                <th style={{ padding:'10px 12px', textAlign:'center', fontSize:12, fontWeight:700 }}>Unit</th>
                <th style={{ padding:'10px 12px', textAlign:'right', fontSize:12, fontWeight:700 }}>Rate</th>
                <th style={{ padding:'10px 12px', textAlign:'right', fontSize:12, fontWeight:700 }}>Amount</th>
              </tr>
            </thead>
            <tbody>
              {items.map((item, i) => (
                <tr key={item.id||i} style={{ borderBottom:'1px solid #E0DFD8', background:i%2===0?'#fff':'#F9F9F7' }}>
                  <td style={{ padding:'9px 12px', fontSize:12, color:'#777' }}>{i+1}</td>
                  <td style={{ padding:'9px 12px', fontSize:13, color:'#1A2E1E', fontWeight:500 }}>{item.description}</td>
                  <td style={{ padding:'9px 12px', fontSize:12, color:'#555', textAlign:'center' }}>{item.quantity}</td>
                  <td style={{ padding:'9px 12px', fontSize:12, color:'#555', textAlign:'center' }}>{item.unit}</td>
                  <td style={{ padding:'9px 12px', fontSize:12, color:'#555', textAlign:'right' }}>{inr(item.rate)}</td>
                  <td style={{ padding:'9px 12px', fontSize:13, fontWeight:700, color:'#153D4B', textAlign:'right' }}>{inr(item.amount)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}

      {/* Summary */}
      <div style={{ display:'flex', justifyContent:'flex-end', marginBottom:24 }}>
        <div style={{ width:320 }}>
          <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', borderBottom:'1px solid #E0DFD8', fontSize:13 }}>
            <span style={{ color:'#555' }}>Subtotal (Taxable Amount)</span>
            <span style={{ fontWeight:700 }}>{inr(invoice.taxable_amount)}</span>
          </div>
          {parseFloat(invoice.cgst||0) > 0 && (
            <>
              <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:12, color:'#777' }}>
                <span>CGST</span>
                <span>{inr(invoice.cgst)}</span>
              </div>
              <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:12, color:'#777' }}>
                <span>SGST</span>
                <span>{inr(invoice.sgst)}</span>
              </div>
            </>
          )}
          {parseFloat(invoice.igst||0) > 0 && (
            <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:12, color:'#777' }}>
              <span>IGST</span>
              <span>{inr(invoice.igst)}</span>
            </div>
          )}
          {invoice.gst_breakdown && (
            <div style={{ fontSize:11, color:'#999', padding:'4px 0', fontStyle:'italic' }}>
              GST: {invoice.gst_breakdown}
            </div>
          )}
          {parseFloat(invoice.discount_amount||0) > 0 && (
            <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:12, color:C.red }}>
              <span>Discount</span>
              <span>-{inr(invoice.discount_amount)}</span>
            </div>
          )}
          <div style={{ display:'flex', justifyContent:'space-between', padding:'12px', background:'#153D4B', color:'#fff', borderRadius:8, marginTop:8 }}>
            <span style={{ fontSize:15, fontWeight:700 }}>TOTAL AMOUNT</span>
            <span style={{ fontSize:18, fontWeight:900 }}>{inr(invoice.total_amount)}</span>
          </div>
          <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:13, marginTop:8 }}>
            <span style={{ color:'#555' }}>Advance Paid</span>
            <span style={{ fontWeight:700, color:C.accent }}>{inr(invoice.advance_paid)}</span>
          </div>
          <div style={{ display:'flex', justifyContent:'space-between', padding:'8px 0', fontSize:14, borderTop:'2px solid #153D4B' }}>
            <span style={{ fontWeight:800, color:'#153D4B' }}>Balance Due</span>
            <span style={{ fontWeight:900, fontSize:16, color:parseFloat(invoice.balance_due||0)>0?C.red:C.accent }}>
              {inr(invoice.balance_due)}
            </span>
          </div>
        </div>
      </div>

      {/* Amount in Words */}
      <div style={{ padding:'12px 16px', background:'#F2F2EC', borderRadius:8, marginBottom:20, fontSize:12 }}>
        <strong>Amount in Words:</strong> {numberToWords(Math.round(invoice.total_amount||0))} Rupees Only
      </div>

      {/* Payment Status */}
      <div style={{ display:'flex', justifyContent:'space-between', alignItems:'center', marginBottom:24 }}>
        <div style={{ padding:'6px 16px', borderRadius:99, fontSize:12, fontWeight:700,
          background:invoice.payment_status==='Paid'?C.accentLight:C.amberBg,
          color:invoice.payment_status==='Paid'?C.accent:C.amber }}>
          {invoice.payment_status}
        </div>
        {invoice.notes && <div style={{ fontSize:12, color:'#777', fontStyle:'italic' }}>{invoice.notes}</div>}
      </div>

      {/* Footer */}
      <div style={{ borderTop:'2px solid #E0DFD8', paddingTop:16, display:'flex', justifyContent:'space-between', alignItems:'flex-end' }}>
        <div style={{ fontSize:11, color:'#999' }}>
          <div>This is a computer-generated invoice.</div>
          <div>Thank you for choosing Botanix Nature Resort!</div>
        </div>
        <div style={{ textAlign:'center' }}>
          <div style={{ height:40, borderBottom:'1px solid #ccc', marginBottom:4, width:150 }}></div>
          <div style={{ fontSize:11, color:'#777' }}>Authorised Signatory</div>
        </div>
      </div>
    </div>
  );
}

function numberToWords(n) {
  const ones = ['','One','Two','Three','Four','Five','Six','Seven','Eight','Nine','Ten','Eleven','Twelve','Thirteen','Fourteen','Fifteen','Sixteen','Seventeen','Eighteen','Nineteen'];
  const tens = ['','','Twenty','Thirty','Forty','Fifty','Sixty','Seventy','Eighty','Ninety'];
  if (n === 0) return 'Zero';
  if (n < 20) return ones[n];
  if (n < 100) return tens[Math.floor(n/10)] + (n%10?' '+ones[n%10]:'');
  if (n < 1000) return ones[Math.floor(n/100)] + ' Hundred' + (n%100?' '+numberToWords(n%100):'');
  if (n < 100000) return numberToWords(Math.floor(n/1000)) + ' Thousand' + (n%1000?' '+numberToWords(n%1000):'');
  if (n < 10000000) return numberToWords(Math.floor(n/100000)) + ' Lakh' + (n%100000?' '+numberToWords(n%100000):'');
  return numberToWords(Math.floor(n/10000000)) + ' Crore' + (n%10000000?' '+numberToWords(n%10000000):'');
}

export default function InvoiceModule() {
  const [invoices, setInvoices] = useState([]);
  const [payModal, setPayModal] = useState(null);
  const [bookings, setBookings] = useState([]);
  const [loading, setLoading] = useState(true);
  const [search, setSearch] = useState('');
  const [filterStatus, setFilterStatus] = useState('');
  const [msg, setMsg] = useState('');
  const [viewInvoice, setViewInvoice] = useState(null);
  const [printMode, setPrintMode] = useState('detailed');
  const [showBookingPicker, setShowBookingPicker] = useState(false);
  const [bookingSearch, setBookingSearch] = useState('');
  const [generating, setGenerating] = useState(false);

  const showMsg = (m) => { setMsg(m); setTimeout(()=>setMsg(''),4000); };

  const load = useCallback(async () => {
    setLoading(true);
    try {
      const [iRes, bRes] = await Promise.all([
        fetch(`${API}/invoices`).then(r=>r.json()),
        fetch(BOOKINGS_API).then(r=>r.json()),
      ]);
      setInvoices(Array.isArray(iRes)?iRes:[]);
      setBookings(Array.isArray(bRes)?bRes:[]);
    } catch(e) {}
    setLoading(false);
  }, []);

  useEffect(()=>{ load(); },[load]);

  const generateInvoice = async (bookingId) => {
    setGenerating(true);
    try {
      const r = await fetch(`${API}/invoices/from-booking/${bookingId}`, {
        method:'POST', headers:{'Content-Type':'application/json'}
      });
      const d = await r.json();
      if (r.ok) {
        setShowBookingPicker(false);
        load();
        setViewInvoice(d);
        showMsg('Invoice generated successfully!');
      } else showMsg(d.error||'Failed to generate');
    } catch(e) { showMsg('Error'); }
    setGenerating(false);
  };

  const updatePaymentStatus = async (id, status) => {
    await fetch(`${API}/invoices/${id}`, {
      method:'PUT', headers:{'Content-Type':'application/json'},
      body: JSON.stringify({ payment_status: status })
    });
    load(); showMsg(`Marked as ${status}`);
  };

  const printInvoice = (mode) => {
    setPrintMode(mode);
    setTimeout(() => {
      const printContent = document.getElementById('invoice-print');
      if (!printContent) return;
      const w = window.open('','_blank');
      w.document.write('<html><head><title>Invoice</title><style>body{margin:0;padding:0;} @media print{.no-print{display:none;}}</style></head><body>');
      w.document.write(printContent.innerHTML);
      w.document.write('</body></html>');
      w.document.close();
      w.print();
    }, 300);
  };

  const filteredInvoices = invoices.filter(i => {
    const matchSearch = !search || i.guest_name?.toLowerCase().includes(search.toLowerCase()) || i.invoice_number?.toLowerCase().includes(search.toLowerCase()) || i.booking_code?.toLowerCase().includes(search.toLowerCase());
    const matchStatus = !filterStatus || i.payment_status === filterStatus;
    return matchSearch && matchStatus;
  });

  const filteredBookings = bookings.filter(b =>
    (!bookingSearch || b.booking_code?.toLowerCase().includes(bookingSearch.toLowerCase()) || b.guest_name?.toLowerCase().includes(bookingSearch.toLowerCase())) &&
    b.booking_status !== 'Cancelled'
  );

  // Already invoiced booking IDs
  const invoicedBookingIds = invoices.map(i=>i.booking_id).filter(Boolean);

  const totalRevenue = invoices.filter(i=>i.payment_status==='Paid').reduce((s,i)=>s+parseFloat(i.total_amount||0),0);
  const totalPending = invoices.filter(i=>i.payment_status!=='Paid').reduce((s,i)=>s+parseFloat(i.balance_due||0),0);

  return (
    <div style={{padding:'24px 28px',background:C.bg,minHeight:'100vh'}}>
      <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:20}}>
        <div>
          <div style={{fontSize:22,fontWeight:800,color:C.text}}>Invoice Management</div>
          <div style={{fontSize:13,color:C.text3,marginTop:4}}>{invoices.length} invoices · Collected: {inr(totalRevenue)} · Pending: {inr(totalPending)}</div>
        </div>
        <button onClick={()=>setShowBookingPicker(true)}
          style={{padding:'9px 18px',background:C.accent,color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>
          + Generate Invoice
        </button>
      </div>

      {msg && <div style={{padding:'10px 16px',borderRadius:10,marginBottom:16,fontSize:13,fontWeight:600,background:C.accentLight,color:C.accent,border:`1px solid ${C.accent}`}}>{msg}</div>}

      {/* Stats */}
      <div style={{display:'grid',gridTemplateColumns:'repeat(4,1fr)',gap:12,marginBottom:20}}>
        {[
          ['Total Invoices',invoices.length,C.text],
          ['Paid',invoices.filter(i=>i.payment_status==='Paid').length,C.accent],
          ['Unpaid',invoices.filter(i=>i.payment_status==='Unpaid').length,C.red],
          ['Partial',invoices.filter(i=>i.payment_status==='Partial').length,C.amber],
        ].map(([label,value,color])=>(
          <div key={label} style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,padding:16,textAlign:'center'}}>
            <div style={{fontSize:24,fontWeight:800,color}}>{value}</div>
            <div style={{fontSize:11,color:C.text3,fontWeight:600,textTransform:'uppercase',marginTop:4}}>{label}</div>
          </div>
        ))}
      </div>

      {/* Filters */}
      <div style={{display:'flex',gap:10,marginBottom:16}}>
        <input value={search} onChange={e=>setSearch(e.target.value)} placeholder="Search invoice, guest, booking..."
          style={{padding:'8px 14px',background:C.surface,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,width:240}} />
        <select value={filterStatus} onChange={e=>setFilterStatus(e.target.value)}
          style={{padding:'8px 12px',background:C.surface,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13}}>
          <option value="">All Status</option>
          <option>Paid</option><option>Unpaid</option><option>Partial</option>
        </select>
        <button onClick={load} style={{padding:'8px 14px',background:C.surface,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text2,fontSize:13,cursor:'pointer'}}>Refresh</button>
      </div>

      {/* Invoice Table */}
      {loading ? <div style={{textAlign:'center',padding:60,color:C.text3}}>Loading...</div> : (
        filteredInvoices.length===0 ? (
          <div style={{textAlign:'center',padding:60,background:C.surface,borderRadius:12,color:C.text3,border:`1px solid ${C.border}`}}>
            No invoices yet. Click "+ Generate Invoice" to create one from a booking.
          </div>
        ) : (
          <div style={{background:C.surface,border:`1px solid ${C.border}`,borderRadius:12,overflow:'hidden'}}>
            <table style={{width:'100%',borderCollapse:'collapse'}}>
              <thead>
                <tr style={{background:C.bg}}>
                  {['Invoice #','Guest','Booking','Check-in','Amount','Advance','Balance','Status','Actions'].map(h=>(
                    <th key={h} style={{padding:'10px 14px',textAlign:'left',fontSize:11,fontWeight:700,color:C.text3,textTransform:'uppercase'}}>{h}</th>
                  ))}
                </tr>
              </thead>
              <tbody>
                {filteredInvoices.map((inv,i)=>(
                  <tr key={inv.id} style={{borderBottom:`1px solid ${C.border}`,background:i%2===0?C.surface:'#F8FAF8'}}>
                    <td style={{padding:'10px 14px',fontFamily:'monospace',fontSize:12,color:C.blue,fontWeight:700}}>{inv.invoice_number}</td>
                    <td style={{padding:'10px 14px',fontWeight:700,color:C.text}}>{inv.guest_name}</td>
                    <td style={{padding:'10px 14px',color:C.text3,fontSize:12}}>{inv.booking_code}</td>
                    <td style={{padding:'10px 14px',color:C.text3,fontSize:12}}>{inv.check_in?new Date(inv.check_in).toLocaleDateString('en-IN'):'—'}</td>
                    <td style={{padding:'10px 14px',fontWeight:800,color:C.text,fontSize:14}}>{inr(inv.total_amount)}</td>
                    <td style={{padding:'10px 14px',color:C.accent,fontWeight:600}}>{inr(inv.advance_paid)}</td>
                    <td style={{padding:'10px 14px',fontWeight:700,color:parseFloat(inv.balance_due||0)>0?C.red:C.accent}}>{inr(inv.balance_due)}</td>
                    <td style={{padding:'10px 14px'}}>
                      <span style={{padding:'3px 10px',borderRadius:99,fontSize:11,fontWeight:700,
                        background:inv.payment_status==='Paid'?C.accentLight:inv.payment_status==='Partial'?C.amberBg:C.redBg,
                        color:inv.payment_status==='Paid'?C.accent:inv.payment_status==='Partial'?C.amber:C.red}}>
                        {inv.payment_status}
                      </span>
                    </td>
                    <td style={{padding:'10px 14px'}}>
                      <div style={{display:'flex',gap:6,flexWrap:'wrap'}}>
                        <button onClick={async()=>{
                          try {
                            const r = await fetch('https://api.botanix.in/api/sessions/invoices/'+inv.id+'/detail');
                            const d = await r.json();
                            setViewInvoice(r.ok ? {...inv,...d, items: d.items||[], guest_name: d.guest_full_name||inv.guest_name, guest_phone: d.guest_phone_full||inv.guest_phone, guest_email: d.guest_email_full||inv.guest_email} : inv);
                          } catch(e) { setViewInvoice(inv); }
                        }}
                          style={{padding:'4px 10px',background:C.accentLight,color:C.accent,border:'none',borderRadius:6,fontSize:11,fontWeight:600,cursor:'pointer'}}>View</button>
                        {inv.payment_status!=='Paid' && (
                          <button onClick={()=>updatePaymentStatus(inv.id,'Paid')}
                            style={{padding:'4px 10px',background:C.blueBg,color:C.blue,border:'none',borderRadius:6,fontSize:11,fontWeight:600,cursor:'pointer'}}>Mark Paid</button>
                        )}
                        {inv.payment_status !== 'Paid' && (
                          <button onClick={()=>setPayModal({booking:{booking_code:inv.booking_code,total_amount:inv.total_amount,advance_paid:inv.advance_paid,balance_amount:inv.balance_due},guest:{full_name:inv.guest_name,email:inv.guest_email,phone:inv.guest_phone}})}
                            style={{padding:'4px 10px',background:'rgba(201,168,76,.15)',color:'#C9A84C',border:'1px solid rgba(201,168,76,.4)',borderRadius:6,fontSize:11,fontWeight:600,cursor:'pointer'}}>
                            💳 Pay
                          </button>
                        )}
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          </div>
        )
      )}

      {/* Booking Picker Modal */}
      {payModal && <PaymentModal booking={payModal.booking} guest={payModal.guest} onClose={()=>setPayModal(null)} onSuccess={()=>setPayModal(null)} />}
      {showBookingPicker && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.5)',zIndex:200,display:'flex',alignItems:'center',justifyContent:'center',padding:16}}>
          <div style={{background:C.surface,borderRadius:16,width:'100%',maxWidth:620,maxHeight:'80vh',overflowY:'auto',padding:28}}>
            <div style={{display:'flex',justifyContent:'space-between',alignItems:'center',marginBottom:16}}>
              <div style={{fontSize:17,fontWeight:800,color:C.text}}>Select Booking to Invoice</div>
              <button onClick={()=>setShowBookingPicker(false)} style={{background:C.bg,border:`1px solid ${C.border}`,borderRadius:8,padding:'6px 12px',cursor:'pointer',color:C.text2}}>Cancel</button>
            </div>
            <input value={bookingSearch} onChange={e=>setBookingSearch(e.target.value)} placeholder="Search booking code or guest name..."
              style={{width:'100%',padding:'9px 14px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13,marginBottom:12,boxSizing:'border-box'}} />
            <div style={{maxHeight:400,overflowY:'auto'}}>
              {filteredBookings.map(b=>(
                <div key={b.id} style={{padding:'12px 16px',borderBottom:`1px solid ${C.border}`,display:'flex',justifyContent:'space-between',alignItems:'center'}}>
                  <div>
                    <div style={{fontSize:14,fontWeight:700,color:C.text}}>{b.guest_name||b.company_name||'Guest'}</div>
                    <div style={{fontSize:12,color:C.text3}}>{b.booking_code} · {b.booking_type} · {b.start_date?new Date(b.start_date).toLocaleDateString('en-IN'):'—'}</div>
                    <div style={{fontSize:12,color:C.text2}}>Total: {inr(b.total_amount)} | Advance: {inr(b.advance_paid)}</div>
                  </div>
                  <div style={{display:'flex',gap:8,alignItems:'center'}}>
                    {invoicedBookingIds.includes(b.id) && (
                      <span style={{fontSize:11,color:C.text3,fontStyle:'italic'}}>Already invoiced</span>
                    )}
                    <button onClick={()=>generateInvoice(b.id)} disabled={generating}
                      style={{padding:'7px 14px',background:C.accent,color:'#fff',border:'none',borderRadius:8,fontSize:12,fontWeight:700,cursor:'pointer',opacity:generating?0.6:1}}>
                      {generating?'...':'Generate'}
                    </button>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>
      )}

      {/* Invoice View Modal */}
      {viewInvoice && (
        <div style={{position:'fixed',inset:0,background:'rgba(0,0,0,.6)',zIndex:300,display:'flex',alignItems:'flex-start',justifyContent:'center',padding:16,overflowY:'auto'}}>
          <div style={{background:C.surface,borderRadius:16,width:'100%',maxWidth:800,marginTop:20}}>
            {/* Controls */}
            <div className="no-print" style={{display:'flex',gap:10,padding:'16px 24px',borderBottom:`1px solid ${C.border}`,alignItems:'center',flexWrap:'wrap'}}>
              <div style={{fontSize:15,fontWeight:800,color:C.text,flex:1}}>{viewInvoice.invoice_number}</div>
              <select value={printMode} onChange={e=>setPrintMode(e.target.value)}
                style={{padding:'7px 12px',background:C.bg,border:`1px solid ${C.border2}`,borderRadius:8,color:C.text,fontSize:13}}>
                <option value="detailed">Detailed Bill (with line items)</option>
                <option value="summary">Summary Bill (amount + GST only)</option>
              </select>
              <button onClick={()=>printInvoice(printMode)}
                style={{padding:'8px 16px',background:C.accent,color:'#fff',border:'none',borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>
                Print / Download
              </button>
              {viewInvoice.payment_status!=='Paid' && (
                <button onClick={()=>{updatePaymentStatus(viewInvoice.id,'Paid');setViewInvoice({...viewInvoice,payment_status:'Paid'});}}
                  style={{padding:'8px 16px',background:C.blueBg,color:C.blue,border:`1px solid ${C.blue}`,borderRadius:8,fontSize:13,fontWeight:700,cursor:'pointer'}}>
                  Mark as Paid
                </button>
              )}
              <button onClick={()=>setViewInvoice(null)}
                style={{padding:'8px 14px',background:C.bg,color:C.text2,border:`1px solid ${C.border}`,borderRadius:8,fontSize:13,cursor:'pointer'}}>
                Close
              </button>
            </div>
            {/* Invoice Preview */}
            <div style={{overflowY:'auto',maxHeight:'80vh'}}>
              <InvoicePrintView invoice={viewInvoice} mode={printMode} />
            </div>
          </div>
        </div>
      )}
    </div>
  );
}
